import React from 'react';
import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';

const Terms = (_props) => {
  const { t } = useTranslation('terms');
  return (
    <div className="legal">
      <Head>
        <title>{t('terms.title')}</title>
      </Head>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <div className="mt-12 mb-24 text-wrap">
          <h1>{t('terms.title')}</h1>
          <p className="mb-8">{t('terms.lastModified')}</p>
          <h3 className="mb-4 mt-8">{t('terms.title1')}</h3>
          <p>{t('terms.sentence1')}</p>
          <h3 className="mb-4 mt-8">{t('terms.title2')}</h3>
          <p>{t('terms.sentence2')}</p>
          <h3 className="mb-4 mt-8">{t('terms.title3')}</h3>
          <p>{t('terms.sentence3')}</p>
          <h3 className="mb-4 mt-8">{t('terms.title4')}</h3>
          <p>{t('terms.sentence4')}</p>
          <h3 className="mb-4 mt-8">{t('terms.title5')}</h3>
          <p>{t('terms.sentence5')}</p>
          <h3 className="mb-4 mt-8">{t('terms.title6')}</h3>
          <p>{t('terms.sentence6')}</p>
          <h3 className="mb-4 mt-8">{t('terms.title7')}</h3>
          <p>{t('terms.sentence7')}</p>
          <h3 className="mb-4 mt-8">{t('terms.title8')}</h3>
          <p>{t('terms.sentence8')}</p>
          <h3 className="mb-4 mt-8">{t('terms.title9')}</h3>
          <p>{t('terms.sentence9')}</p>
          <h3 className="mb-4 mt-8">{t('terms.title10')}</h3>
          <p>{t('terms.sentence10')}</p>
          <h3 className="mb-4 mt-8">{t('terms.title11')}</h3>
          <p>{t('terms.sentence11')}</p>
        </div>
      </div>
    </div>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common', 'terms'])),
  },
});

export default Terms;
